import { CloseOutlined, DeleteOutlined, EditOutlined, EnvironmentOutlined, PlusOutlined } from '@ant-design/icons';
import { Divider, Tag, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ApiHandler } from '../../services/apiHandler';
import { getTechnology, getTechnologyDisplayValue } from '../../services/helper';
import ConfirmAlert from '../confirmAlert';
import ErrorAlert from '../ErrorAlert';
import LevelSelectorGeoJson from '../GeoJsonLevel';
import PrimaryButton from '../PrimaryButton';
import Spinner from '../Spinner';
import SuccessAlert from '../SuccessAlert';
import WarningAlert from '../WarningAlert';
import './_buildingdetails.css';
import { IBuildingDetailsProps } from './IBuildingDetailsProps';

export const BuildingDetails: React.FC<IBuildingDetailsProps> = (props) => {
  const { Title, Text } = Typography;

  let navigate = useNavigate();
  const [floors, setFloors] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [totalAssets, setTotalAssets]: any = useState();
  const [outdoorAssets, setOutdoorAssets]: any = useState();
  const [totalAssetStatus, setTotalAssetStatus]: any = useState({ fieldTech: 0, cloud: 0, sas: 0, afc: 0 });
  const [outdoorAssetStatus, setOutdoorAssetStatus]: any = useState({ fieldTech: 0, cloud: 0, sas: 0 });
  const [error, setError] = useState({
    message: '',
    alert: false,
  });
  const [warning, setWarning] = useState({
    message: '',
    alert: false,
  });
  const [success, setSuccess] = useState({
    message: '',
    alert: false,
  });
  const [deleteBuildingConfirmModal, setDeleteBuildingConfirmModal] = useState({ alert: false, message: '' });
  const [assets, setAssets]: any = useState();
  const [selectedFloorIndex, setSelectedFloorIndex] = useState(0);
  const [deleteFloorConfirmModal, setDeleteFloorConfirmModal] = useState(false);
  const [floorPlanGeometry, setFloorPlanGeometry] = useState<any>([]);

  useEffect(() => {
    props.setFloorId(null);
  }, []);

  useEffect(() => {
    if (props.assets && props.assets.length > 0) {
      setAssets(props.assets);
      setTotalAssets(props.assets?.length);
      var fieldTech = 0;
      var cloud = 0;
      var sas = 0;
      var afc = 0;
      props.assets.map((asset) => {
        if (asset.status == 'Field Tech') fieldTech += 1;
        else if (asset.status == 'Cloud') cloud += 1;
        else if (asset.status == 'SAS') sas += 1;
        else if (asset.status == 'Submitted to AFC') afc += 1;
      });
      setTotalAssetStatus({
        fieldTech: fieldTech,
        cloud: cloud,
        sas: sas,
        afc: afc,
      });
    } else {
      setAssets([]);
      setTotalAssets(0);
      setTotalAssetStatus({
        fieldTech: 0,
        cloud: 0,
        sas: 0,
        afc: 0,
      });
    }
  }, [props.assets]);

  // useEffect(() => {
  //   // getBuildingDetails();
  //   getFirstBuildingDetails();
  // }, [props.venue_id]);

  useEffect(() => {
    getBuildingDetails();
    if (props.buildingId) listFloors();
  }, [props.buildingId]);

  const getFirstBuildingDetails = () => {
    setLoading(true);
    ApiHandler({ apiName: 'getFirstBuildingDetails', body: {}, params: { venue_id: props.venueId } })
      .then((res) => {
        setLoading(false);
        props.setBuilding(res.data);
        typeof props.setBuildingId === 'function' && props.setBuildingId(res.data.id);
        setAssets(res.data.assets);
        setTotalAssets(res.data.total_assets);
        setOutdoorAssets(res.data.asset_on_building);
        setTotalAssetStatus({
          fieldTech: res.data.total_field_tech,
          cloud: res.data.total_cloud,
          sas: res.data.total_sas,
          afc: 0,
        });
        setOutdoorAssetStatus({
          fieldTech: res.data.outdoor_field_tech,
          cloud: res.data.outdoor_cloud,
          sas: res.data.outdoor_sas,
        });
        var tempGeomList: any[] = [];
        res?.data?.floor?.length > 0 &&
          res.data.floor.map((floor: any, index: number) => {
            if (floor?.floor_plan_footprint_geom) {
              const floorGeojson = JSON.parse(floor?.floor_plan_footprint_geom);
              console.log(floorGeojson, 'floor?.floor_plan_footprint_geom');

              var tempGeom = {
                type: 'Feature',
                properties: {
                  id: (index + 1).toString(),
                  levelNumber: index + 1,
                  color: '#0b0b0aff',
                },
                geometry: {
                  coordinates: floorGeojson.coordinates,
                  type: 'Polygon',
                },
              };
              tempGeomList.push(tempGeom);
            }
          });
        // setFloorPlanGeometry(tempGeomList);
        res.data.floor.sort((a: any, b: any) => a.floor_number - b.floor_number);
        setFloors(res.data.floor);
        typeof props.setSelectedFloor === 'function' && props.setSelectedFloor(res.data.floor[0]);
        props.setFloorId(res.data.floor[0]?.id);
      })
      .catch((error: any) => {
        setLoading(false);
        if (error.doLogout === true) {
          setError({ message: 'Session Timed Out', alert: true });
          setTimeout(() => navigate('/login', { replace: true }), 2000);
        } else {
          setError({ message: error.data.message, alert: true });
        }
      });
  };

  const getBuildingDetails = () => {
    setLoading(true);
    ApiHandler({ apiName: 'getBuilding', body: {}, params: { building_id: props.buildingId } })
      .then((res) => {
        setLoading(false);
        props.setBuilding(res.data);
        if (res?.data?.polygon_points) {
          var tempGeomList: any[] = [];
          var coordinatesArray: any[] = [];
          if (res?.data?.total_floors && res?.data?.polygon_points?.length > 0) {
            res?.data?.polygon_points.map((point: any) => {
              coordinatesArray.push([point.lng, point.lat]);
            });
            for (let i = 0; i < res?.data?.total_floors; i++) {
              var tempGeom = {
                type: 'Feature',
                properties: {
                  id: (i + 1).toString(),
                  levelNumber: i + 1,
                  color: '#2c00f1ff',
                  height: 30,
                  stroke: '#eb0c0cff',
                },
                geometry: {
                  coordinates: [coordinatesArray],
                  type: 'Polygon',
                },
                legendProps: {
                  color: '#000000ff',
                  selectColor: '#2c00f1ff',
                },
              };
              tempGeomList.push(tempGeom);
            }
          }
          setFloorPlanGeometry(tempGeomList);
        }
        // setAssets(res.data.assets);
        // setTotalAssets(res.data.total_assets);
        // setOutdoorAssets(res.data.asset_on_building);
        // setTotalAssetStatus({
        //   fieldTech: res.data.total_field_tech,
        //   cloud: res.data.total_cloud,
        //   sas: res.data.total_sas,
        // });
        // setOutdoorAssetStatus({
        //   fieldTech: res.data.outdoor_field_tech,
        //   cloud: res.data.outdoor_cloud,
        //   sas: res.data.outdoor_sas,
        // });
      })
      .catch((error: any) => {
        setLoading(false);
        if (error.doLogout === true) {
          setError({ message: 'Session Timed Out', alert: true });
          setTimeout(() => navigate('/login', { replace: true }), 2000);
        } else {
          setError({ message: error.data.message, alert: true });
        }
      });
  };

  const listFloors = (id: number = -1) => {
    setLoading(true);
    ApiHandler({ apiName: 'listFloors', body: {}, params: { building_id: id !== -1 ? id : props.buildingId } })
      .then((res) => {
        setLoading(false);
        res.data.sort((a: any, b: any) => a.floor_number - b.floor_number);
        setFloors(res.data);
        // var tempGeomList: any[] = [];
        // res?.data?.length > 0 &&
        //   res.data.map((floor: any, index: number) => {
        //     if (floor?.floor_plan_footprint_geom) {
        //       const floorGeojson = JSON.parse(floor?.floor_plan_footprint_geom);
        //       console.log(floorGeojson, 'floor?.floor_plan_footprint_geom');

        //       var tempGeom = {
        //         type: 'Feature',
        //         properties: {
        //           id: floor.floor_number.toString(),
        //           levelNumber: floor.floor_number,
        //           color: '#2c00f1ff',
        //         },
        //         geometry: {
        //           coordinates: floorGeojson.coordinates,
        //           type: 'Polygon',
        //         },
        //       };
        //       tempGeomList.push(tempGeom);
        //     }
        //   });
        // setFloorPlanGeometry(tempGeomList);
        props.setFloorId(res.data?.[0]?.id);
        props.setSelectedFloor && props.setSelectedFloor(res.data?.[0]);
      })
      .catch((error: any) => {
        setLoading(false);
        if (error.doLogout === true) {
          setError({ message: 'Session Timed Out', alert: true });
          setTimeout(() => navigate('/login', { replace: true }), 2000);
        } else {
          setError({ message: error.data.message, alert: true });
        }
      });
  };

  const deleteBuilding = () => {
    setLoading(true);
    ApiHandler({ apiName: 'deleteBuilding', body: {}, params: { building_id: props.buildingId } })
      .then((res) => {
        setLoading(false);
        setSuccess({ message: 'Building Deleted Successfully', alert: true });
        setTimeout(() => {
          props.navigateTo('venueDetails');
        }, 1000);
      })
      .catch((error: any) => {
        setLoading(false);
        if (error.doLogout === true) {
          setError({ message: 'Session Timed Out', alert: true });
          setTimeout(() => navigate('/login', { replace: true }), 2000);
        } else {
          setError({ message: error.data.message, alert: true });
        }
      });
  };

  const goToFloor = (floor: any) => {
    props.setFloorId(floor?.id);
    // props.navigateTo('floorDetails');
    if (typeof props.setSelectedFloor === 'function') props.setSelectedFloor(floor);
  };

  const checkFloorsInBuilding = () => {
    if (floors?.length != 0) {
      setWarning({ message: 'Please delete floors before deleting buildings', alert: true });
    } else {
      let deleteMessage: string = '<span>Following assets are present.</span><br/><br/><ul>';
      assets.forEach((asset: any) => {
        deleteMessage += '<li>' + asset.tracking_id + '</li>';
      });
      deleteMessage +=
        '</ul><i>On confirming the deletion, the assets will <b>automatically be dissociated from the building</b> but will still remain associated to the venue <br/><br/> Do you want to proceed?</i>';
      setDeleteBuildingConfirmModal(
        assets?.length ? { alert: true, message: deleteMessage } : { alert: true, message: 'Are you sure you want to delete the building' }
      );
    }
  };

  const removeAssetsBuilding = () => {
    setLoading(true);
    const requestBody: any = { asset_ids: [] };
    assets.forEach((asset: any) => {
      requestBody.asset_ids.push(asset.id);
    });
    ApiHandler({ apiName: 'removeAssetFromBuilding', body: requestBody, params: {} })
      .then((response: any) => {
        setLoading(false);
        deleteBuilding();
      })
      .catch((error: any) => {
        setLoading(false);
        if (error.doLogout === true) {
          setError({ message: 'Session Timed Out', alert: true });
          setTimeout(() => navigate('/login', { replace: true }), 2000);
        } else {
          setError({ message: error.data.message, alert: true });
        }
      });
  };

  const getFloorLabel = (floorType: string) => {
    switch (floorType) {
      case 'Basement':
        return 'B';
      case 'Parking':
        return 'P';
      default:
        return 'F';
    }
  };

  const deleteFloor = () => {
    setLoading(true);
    ApiHandler({ apiName: 'deleteFloor', body: {}, params: { floor_id: props.floorId } })
      .then((res) => {
        setLoading(false);
        setSuccess({ message: 'Floor Deleted Successfully', alert: true });
        setTimeout(() => {
          props.setFloorId(null);
          listFloors();
          // props.navigateTo('buildingDetails');
        }, 1000);
      })
      .catch((error: any) => {
        setLoading(false);
        if (error.doLogout === true) {
          setError({ message: 'Session Timed Out', alert: true });
          setTimeout(() => navigate('/login', { replace: true }), 2000);
        } else {
          setError({ message: error.data.message, alert: true });
        }
      });
  };

  const changeFloorFromdesignerModule = (level: any) => {
    const index = floors.findIndex((floor) => floor.floor_number == level);
    if (index !== -1) {
      setSelectedFloorIndex(index);
      goToFloor(floors[index]);
    }
  };

  return (
    <div className="overflow-auto h-100 row-wise justify-content-between">
      <div className="app-card position-relative app-card-size right">
        <div className="row-wise vertical-center justify-content-between">
          {/* <div className="row-wise vertical-center ">
            <div
              className="icon-background-active"
              onClick={() => {
                props.navigateTo("venueDetails");
              }}
            >
              <span className="material-icons-round icon-active">arrow_back</span>
            </div>
            <label className="building-name ms-3">{building?.name}</label>
          </div> */}

          <div className="row-wise vertical-center space-between px-4 py-2 w-100">
            <div className="col-wise">
              {/* <span className="app-card-action-heading fw-bold"> {building?.name}</span>  //ADDING CBSD */}
              <Title className="text-uppercase py-1 mb-0" level={5}>
                {props.building?.name}
              </Title>
              {props.building?.address && (
                <div className="row-wise gap-8 vertical-center">
                  <EnvironmentOutlined className="info-icon-blue " />
                  {/* <span className="entity-label-address">{building?.address}</span> */}
                  <Text type="secondary" className="entity-label-address" style={{ width: 200 }} ellipsis={{ tooltip: props.building?.address }}>
                    {props.building?.address}
                  </Text>
                </div>
              )}
            </div>
            <div className="vertical-center">
              {/* Edit and delete options */}
              <div className="btn-group dropstart me-3" style={{ zIndex: 1000 }}>
                <span
                  title="Options"
                  className="material-icons-round user-select-none cursor-pointer "
                  data-bs-toggle="dropdown"
                  aria-expanded="false">
                  more_vert
                </span>
                <ul className="dropdown-menu">
                  <li>
                    <button
                      className="dropdown-item"
                      type="button"
                      onClick={() => {
                        props.navigateTo('editBuilding');
                      }}>
                      Edit
                    </button>
                  </li>
                  <li>
                    <button
                      className="dropdown-item color-red"
                      type="button"
                      onClick={() => {
                        checkFloorsInBuilding();
                      }}>
                      Delete
                    </button>
                  </li>
                </ul>
              </div>
              <CloseOutlined
                onClick={() => {
                  if (props.venueId) {
                    props.navigateTo('venueDetails');
                  } else {
                    props.navigateTo('home');
                  }
                  typeof props.setSelectedFloor == 'function' && props.setSelectedFloor(null);
                  setFloorPlanGeometry(null);
                }}
                className="fs-6"
              />
              {/* <span className="material-icons-round icon-active">arrow_back</span> */}
            </div>
          </div>
        </div>
        <div className="border-bottom" />

        {/* <hr style={{ borderTop: "5px solid #e5e5e5" }}></hr> */}

        {/* Building Details */}

        <div className="col-wise overflow-auto h-100">
          {/* <span className="text-color-secondary mb-2">Description</span> */}
          {/* <span className="text-color-secondary mb-3 ps-1">
            {building?.description ? building?.description : <em style={{ color: 'gray' }}>No description added</em>}
          </span> */}
          <LevelSelectorGeoJson
            floorPlanGeometry={floorPlanGeometry}
            changeLevel={changeFloorFromdesignerModule}
            floorDetails={floors[selectedFloorIndex]}
          />

          {/* <span className="text-color-secondary mb-2">Address</span> */}
          {/* <span className="entity-label mb-3">{building?.address}</span> */}
          <div className="row-wise justify-content-between my-2 vertical-center px-4">
            <Text strong className="floor-title">
              Levels
            </Text>
            {/* <span
              title="Add New Floor"
              className="material-icons-round add-floor-icon"
              onClick={() => {
                props.setFloorActionType('add');
                props.navigateTo('floorActions');
              }}>
              add_circle_outline
            </span> */}
            <div
              onClick={() => {
                props.setFloorActionType('add');
                props.navigateTo('floorActions');
              }}
              className="vertical-center info-icon-blue add-new">
              <PlusOutlined title="Add new floor" className="info-icon-blue me-1" />
              <Text className="info-icon-blue">Add</Text>
            </div>
          </div>

          {/* <div className="floors-box">
            {floors && floors?.length > 0 ? (
              floors.map((floor: any, index: number) => {
                return (
                  <div
                    key={`${floor?.id}-floor`}
                    className={props.floorId === floor?.id ? "floor-selected" : "floor-default"}
                    onClick={() => {
                      if (floor?.id !== props.floorId) {
                        props.setFloorId(floor?.id);
                      }
                    }}
                  >
                    <span>{"F" + floor.floor_number}</span>
                  </div>
                );
              })
            ) : (
              <></>
            )}
          </div> */}

          {/* Floor Details */}
          <div className="overflow-auto h-100 col-wise mt-1 px-4">
            {floors && floors?.length > 0 ? (
              // floors?.map((floor: any, index: number) => {
              //   // if (floor?.id === props.floorId) {
              //   return (
              //     <div
              //       key={`${floor.id}-floor-card`}
              //       className={'floor-card ' + ` ${index == 0 ? ' rounded-top-6 ' : index == floors.length + 1 ? ' rounded-bottom-6 ' : ''}`}
              //       onClick={() => {
              //         props.setFloorId(floor?.id);
              //         goToFloor(floor);
              //       }}>
              //       {/* Image */}
              //       {/* {floor.image && floor.image !== "" ? (
              //           <img src={floor.image} className=" floor-image-box image" />
              //         ) : (
              //           <div className="floor-image-box">
              //             <span className="material-icons-outlined icon">dashboard</span>
              //           </div>
              //         )} */}
              //       {/* Details */}
              //       <div className="floor-details ms-3">
              //         <div className="row-wise vertical-center justify-content-between w-100 mb-2">
              //           <label className="building-details">
              //             {getFloorLabel(floor?.floor_type)}
              //             {floor?.floor_number}
              //           </label>
              //         </div>
              //         {/* <label className="description mb-2 h-100">{floor.description}</label> */}
              //         {/* <label className="total-floors">{floor.total_floors} Floors</label> */}
              //       </div>
              //       <div className="ro-wise vertical-center gap-8">
              //         <label className="description">{`${floor?.total_assets} ${getTechnologyDisplayValue[getTechnology()]} devices`}</label>
              //         <span className="material-icons-outlined icon">navigate_next</span>
              //       </div>
              //     </div>
              //   );
              //   // }
              // })
              <>
                <div className="d-none">
                  {floors?.map((floor: any, index: number) => {
                    return (
                      <Tag
                        color={selectedFloorIndex == index ? 'geekblue' : undefined}
                        className="mb-1 tag-floors"
                        onClick={() => {
                          setSelectedFloorIndex(index);
                          goToFloor(floor);
                        }}>
                        {floor?.floor_number}
                      </Tag>
                    );
                  })}
                </div>
                <Divider className="mb-3 mt-1" />
                <div className="col-wise h-100">
                  <div className="row-wise justify-content-between mb-3">
                    <Text strong className="mb-1">
                      {`${getTechnologyDisplayValue[getTechnology()]} Devices`}
                    </Text>
                    <div className="row-wise gap-3 vertical-center">
                      <EditOutlined
                        style={{ color: '#1677FF', fontSize: '14px' }}
                        onClick={() => {
                          props.setFloorActionType('edit');
                          props.navigateTo('floorActions');
                        }}
                      />
                      <DeleteOutlined style={{ color: '#d11a2a', fontSize: '14px' }} onClick={() => setDeleteFloorConfirmModal(true)} />
                    </div>
                  </div>
                  <div className="row-wise mb-3">
                    <div className="w-100 me-1 result-box col-wise my-4">
                      <Text
                        strong
                        // className="result-title"
                      >
                        On This Floor
                      </Text>

                      <div className="row-wise align-items-center justify-content-start">
                        <div style={{ marginTop: 'auto', paddingBottom: '8px' }} className="d-flex col-wise justify-content-cente">
                          <div className="row-wise align-items-center mb-2 justify-content-center">
                            <Text
                              strong
                              className="me-2"
                              style={{ fontSize: '36px' }}
                              // className="result-label"
                            >
                              {totalAssets}
                            </Text>
                          </div>
                          <Text strong className="me-2">
                            Total Assets
                          </Text>
                        </div>
                        <div className="ms-4 ps-4">
                          <div className="row-wise align-items-center mb-2">
                            <div title="Field Tech" className="field-tech-circle me-1"></div>
                            <Text strong title="Field Tech" className="me-2">
                              {totalAssetStatus.fieldTech}
                            </Text>
                            <Text className="me-2">Field Tech</Text>
                          </div>
                          <div className="row-wise align-items-center mb-2">
                            <div title="Cloud" className="cloud-circle me-1"></div>
                            <Text
                              strong
                              title="Cloud"
                              className="me-2"
                              // className="me-2 result-title"
                            >
                              {totalAssetStatus.cloud}
                            </Text>
                            <Text className="me-2">Cloud</Text>
                          </div>
                          {getTechnology() !== 'wifi_6e' && (
                            <div className="row-wise align-items-center mb-2">
                              <div className="row-wise align-items-center">
                                <div title="SAS" className="sas-circle me-1"></div>
                                <Text strong title="SAS" className="me-2">
                                  {totalAssetStatus.sas}
                                </Text>
                                <Text className="me-2">SAS</Text>
                              </div>
                            </div>
                          )}
                          {getTechnology() !== 'cbrs_5g' && (
                            <div className="row-wise align-items-center mb-2">
                              <div className="row-wise align-items-center">
                                <div title="Submitted to AFC" className="sas-circle me-1"></div>
                                <Text strong title="Submitted to AFC" className="me-2">
                                  {totalAssetStatus.afc}
                                </Text>
                                <Text className="me-2">AFC</Text>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <Text
                    strong
                    // className="text-color-secondary mb-2"
                  >
                    Floor Type
                  </Text>
                  <Text
                    type="secondary"
                    className="mb-2"
                    // className="entity-label mb-3"
                  >
                    {floors[selectedFloorIndex]?.floor_type}
                  </Text>

                  <Text strong>Description</Text>
                  <Text type="secondary" className="mb-2">
                    {floors[selectedFloorIndex]?.description ? (
                      floors[selectedFloorIndex]?.description
                    ) : (
                      <Text type="secondary">No description added</Text>
                    )}
                  </Text>

                  <Text strong>Base from Ground</Text>
                  <Text className="entity-label mb-2">{floors[selectedFloorIndex]?.base_from_ground} ft</Text>

                  <Text strong>Ceiling from Ground</Text>
                  <Text className="mb-2">{floors[selectedFloorIndex]?.ceiling_from_ground} ft</Text>

                  <Text strong>Floor Base Thickness</Text>
                  <Text className="mb-2">{floors[selectedFloorIndex]?.floor_base_thickness} ft</Text>
                </div>
              </>
            ) : (
              <div className="text-center px-4">No Floors Added</div>
            )}
            {/* <div className="row-wise ps-1">
              <div className="w-50 me-1">
                <div className="vertical-center justify-content-start">
                  <Text type="secondary">Inside Building - </Text>
                  <Text type="secondary" title="Total" className="result-label-new ms-1">
                    {totalAssets}
                  </Text>
                </div>
                <div className="row-wise justify-content-start mt-1">
                  <div className="vertical-center">
                    <div title="Field Tech" className="field-tech-circle me-1"></div>
                    <Text type="secondary" title="Field Tech" className="me-2 result-title">
                      {totalAssetStatus.fieldTech}
                    </Text>
                  </div>
                  <div className="vertical-center">
                    <div title="Cloud" className="cloud-circle me-1"></div>
                    <Text type="secondary" title="Cloud" className="me-2 result-title">
                      {totalAssetStatus.cloud}
                    </Text>
                  </div>
                  {getTechnology() == 'cbrs_5g' && (
                    <div className="vertical-center">
                      <div title="SAS" className="sas-circle me-1"></div>
                      <Text type="secondary" title="SAS" className="me-2 result-title">
                        {totalAssetStatus.sas}
                      </Text>
                    </div>
                  )}
                </div>
              </div>
              <div className="w-50 ms-1">
                <div className="vertical-center justify-content-start">
                  <Text type="secondary">Outside Building - </Text>
                  <Text type="secondary" title="Total" className="result-label-new ms-1">
                    {outdoorAssets}
                  </Text>
                </div>

                <div className="row-wise justify-content-start mt-1">
                  <div className="vertical-center">
                    <div title="Field Tech" className="field-tech-circle me-1"></div>
                    <Text type="secondary" title="Field Tech" className="me-2 result-title">
                      {outdoorAssetStatus.fieldTech}
                    </Text>
                  </div>
                  <div className="vertical-center">
                    <div title="Cloud" className="cloud-circle me-1"></div>
                    <Text type="secondary" title="Cloud" className="me-2 result-title">
                      {outdoorAssetStatus.cloud}
                    </Text>
                  </div>
                  {getTechnology() == 'cbrs_5g' && (
                    <div className="vertical-center">
                      <div title="SAS" className="sas-circle me-1"></div>
                      <Text type="secondary" title="SAS" className="me-2 result-title">
                        {outdoorAssetStatus.sas}
                      </Text>
                    </div>
                  )}
                </div>
              </div>
            </div> */}
          </div>
          {/* <div className="h-100 mb-3 align-content-start">
              <div className="overflow-auto floor-list vertical-center">
          
              </div>
            </div> */}
        </div>
        <div className="px-4 py-3 d-none">
          <PrimaryButton
            clicked={() => {
              props.navigateTo('venueDetails');
            }}
            label="Back To Venue"
          />
        </div>
      </div>

      <Spinner show={loading} />

      {/* Delete Building confirmation modal */}
      <ConfirmAlert
        message={deleteBuildingConfirmModal.message}
        primaryText={'Yes'}
        secondaryText={'No'}
        secondaryAction={() => {
          setDeleteBuildingConfirmModal({ alert: false, message: '' });
        }}
        visible={deleteBuildingConfirmModal.alert}
        title={'Delete Building'}
        primaryAction={() => {
          setDeleteBuildingConfirmModal({ alert: false, message: '' });
          assets?.length !== 0 ? removeAssetsBuilding() : deleteBuilding();
        }}
        onClose={() => {
          setDeleteBuildingConfirmModal({ alert: false, message: '' });
        }}
      />

      <ErrorAlert
        show={error.alert}
        onDismiss={() => {
          setError({ message: '', alert: false });
        }}
        message={error.message}
      />
      <SuccessAlert
        show={success.alert}
        onDismiss={() => {
          setSuccess({ message: '', alert: false });
        }}
        message={success.message}
      />
      <WarningAlert
        show={warning.alert}
        onDismiss={() => {
          setWarning({ message: '', alert: false });
        }}
        message={warning.message}
      />

      {/* Delete Floor confirmation modal */}
      <ConfirmAlert
        message={`Are you sure you want to delete the floor?`}
        primaryText={'Yes'}
        secondaryText={'No'}
        secondaryAction={() => {
          setDeleteFloorConfirmModal(false);
        }}
        visible={deleteFloorConfirmModal}
        title={'Delete Floor'}
        primaryAction={() => {
          setDeleteFloorConfirmModal(false);
          deleteFloor();
          getBuildingDetails();
          listFloors();
          // getFirstBuildingDetails();
        }}
        onClose={() => {
          setDeleteFloorConfirmModal(false);
        }}
      />
    </div>
  );
};
